import { makeAutoObservable } from 'mobx'

import { MONDU_KEY } from 'constants/options.constants'

import { ShopRootStore } from 'shop/stores/shopRoot.store'
import {
  CURRENCY_COUNTRY_MAP,
  MONDU_COUNTRIES,
  PAYER_FORM_TYPE,
  STIPE_ELEMENT_OPTIONS_DEFAULT,
} from 'constants/paymentSettingShared.constants'
import { StripeElementsOptionsMode } from 'shop/types/stripe'
import { PAYMENT_PLANS } from 'constants/pricingPlans.constants'
import {
  StripePaymentMethod,
  StripePaymentMethodShop,
} from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopMonduPaymentMethodStore implements StripePaymentMethod, StripePaymentMethodShop {
  storeName = 'shopMonduPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  isAppActive() {
    return this.root.sellerStore.isAppActive(MONDU_KEY)
  }

  isEnabled() {
    return this.root.sellerStore.item?.monduEnabled
  }

  isAvailable = (activeCountry: string, currency: string): boolean =>
    this.isAppActive() &&
    MONDU_COUNTRIES.includes((activeCountry || 'DE').toUpperCase()) &&
    CURRENCY_COUNTRY_MAP[currency.toUpperCase()]?.includes(activeCountry)

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
  }): StripeElementsOptionsMode => {
    if (isDealsPage) {
      return (
        (this.root.dealsStore?.getMonduStripeElementPayload && this.root.dealsStore.getMonduStripeElementPayload()) ||
        STIPE_ELEMENT_OPTIONS_DEFAULT
      )
    } else if (isManagePage) {
      return (
        (this.root.ordersStore?.getMonduStripeElementPayload && this.root.ordersStore.getMonduStripeElementPayload()) ||
        STIPE_ELEMENT_OPTIONS_DEFAULT
      )
    } else {
      return (
        (this.root.paymentStore?.getMonduStripeElementPayload &&
          this.root.paymentStore.getMonduStripeElementPayload()) ||
        STIPE_ELEMENT_OPTIONS_DEFAULT
      )
    }
  }

  isAvailableForPayerType = () => {
    const privateTypes = [PAYER_FORM_TYPE.private, PAYER_FORM_TYPE.private250]

    const formTypeFromPayment = this.root.paymentStore.payerForms?.formType
    const formTypeFromOrder = this.root.ordersStore.data?.payerData?.formType

    return !privateTypes.includes(formTypeFromPayment) && !privateTypes.includes(formTypeFromOrder)
  }

  isAvailableForPricingPlan = ({ withTestPeriod, withCustomStart, pricingPlanForm }) =>
    !withTestPeriod && !withCustomStart && pricingPlanForm === PAYMENT_PLANS.oneTime
}
